import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {LogadoService} from "../../../providers/logado-service";
import {CONFIG} from "../../../app/config";
import {TAction, TContatoTipo, TContatoFlag, TProfileFlag} from "../../../app/enum";
import {ProfileService} from "../../../providers/profile-service";
import {DataService} from "../../../providers/data-service";
import {TStatusBar, Util} from "../../../app/util";
import {HttpService} from "../../../providers/http-service";


@Component({
    selector: 'page-contato-menu',
    templateUrl: 'contato-menu.html',
    providers: [ProfileService]
})
export class ContatoMenuPage {

    TContatoTipo: any = TContatoTipo;
    TContatoFlag: any = TContatoFlag;

    config: any;

    logado: any;
    rootile: any;
    copyile: any;

    contato: any;

    etapa: number; //Escolha | Digitar | Confirm
    etape: number; //Backup

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public http: HttpService, public logadoService: LogadoService,
                public util: Util, public dataService: DataService, public profileService: ProfileService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.navParams.get('copyile');
        this.contato = this.navParams.get('contato');

        this.etapa = this.navParams.get('etapa');
        this.etape = this.navParams.get('etapa');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    getTitle() {

        if (this.etapa == 0) return 'Contato';
        if (this.etapa == 1) return this.contatoFlug(this.contato.ContatoRede, 'texto');

    }

    esqueciOito() {

        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acLost, null, '&ProfileRnid=' + this.copyile.Profile.ProfileRnid)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.alertSimply('Senha enviada para seu e-mail.', 'Pronto!'),
                erro => this.util.alertResult(erro)
            );

    }

    contatoAuth(foto) {

        this.contato.ContatoFoto = foto;
        this.contato.ContatoFlag = TContatoFlag.cfCode;

    }

    contatoNext() {

        let verificCode = (this.contato.ContatoRede == TContatoTipo.coFace && this.copyile.Profile.ProfileCnpj);

        if (verificCode && !this.contato.ContatoCode) {
            this.util.alertSimply('Informe o ' + this.contatoFlug(this.contato.ContatoRede, 'texto'));
            return;
        }

        //USUARIO - UsuarioPara: US.Para
        let usuarioPara = !this.copyile;

        if (!verificCode && !this.contato.ContatoUser && !usuarioPara) {
            this.util.alertSimply('Informe o ' + this.contatoFlug(this.contato.ContatoRede, 'texto'));
            return;
        }


        if ([TContatoTipo.coOlha, TContatoTipo.coMail, TContatoTipo.coInst].indexOf(this.contato.ContatoRede) >= 0 &&
           (this.contato.ContatoUser.indexOf(':') >= 0 ||
            this.contato.ContatoUser.indexOf('/') >= 0 ||
            this.contato.ContatoUser.indexOf(' ') >= 0 ||
            this.contato.ContatoUser.indexOf('www') >= 0 ||
            this.contato.ContatoUser.length > 50
           )) {
            this.util.alertSimply('Inválido, verifique!');
            return;
        }

        if (this.contato.ContatoRede == TContatoTipo.coOlha ||
            this.contato.ContatoRede == TContatoTipo.coFone ||
            this.contato.ContatoRede == TContatoTipo.coMail ||
            this.contato.ContatoRede == TContatoTipo.coChip ||
            this.contato.ContatoRede == TContatoTipo.coInst) {
            this.contatoSave(this.contato);
        }


        /*if (this.contato.ContatoRede == TContatoTipo.coMail ||
            this.contato.ContatoRede == TContatoTipo.coChip) {
            this.contato.ContatoFlag = TContatoFlag.cfCode;
        }*/

        if (this.contato.ContatoRede == TContatoTipo.coFace) {
            let loading = this.util.loadingDots();
            loading.present();

            let link = 'https://graph.facebook.com/' + this.contato.ContatoCode + '/picture?width=100';
            this.util.getBase64Image(link)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => this.contatoAuth(data),
                    erro => this.util.alertSimply('Não encontramos seu facebook.'));
        }

        // if (this.contato.ContatoRede == TContatoTipo.coInst) {
        //     let loading = this.util.loadingDots();
        //     loading.present();

        //     //let link = 'https://www.instagram.com/'  + this.contato.ContatoUser.replace('@', '');
        //     let link = 'http://localhost:3000/auth/instagram';//  + this.contato.ContatoUser.replace('@', '');
        //     this.util.getog(link)
        //         .finally(() => loading.dismiss())
        //         .subscribe(
        //             data => this.contatoAuth(data.image),
        //             erro => this.util.alertSimply('Não encontramos seu instagram.'));
        // }

        if (this.contato.ContatoRede == TContatoTipo.coTwit) {
            let loading = this.util.loadingDots();
            loading.present();

            let link = 'https://www.twitter.com/'  + this.contato.ContatoUser.replace('@', '');
            this.util.getog(link)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        this.http.get(link, {}, false)
                            .map(date => {

                                console.log(date.user.legacy.profile_image_url_https);

                            });

                    },
                    erro => this.util.alertSimply('Não encontramos seu twitter.'));

        }


    }

    contatoSave(contato, acLixo?) {

        //USUARIO - UsuarioPara: US.Para
        if (!this.copyile) {
            if (this.contato.ContatoUser && !this.util.validaEmail(this.contato.ContatoUser)) {
                this.util.alertSimply('Informe email válido');
                return;
            }
            this.viewCtrl.dismiss({result: 'just-call-subscribe'});
            return;
        }

        let onDone = () => {

            //Grava copyile para rootile
            this.copyile.Contatos.push(this.contato);
            this.util.populateObj(this.rootile, this.copyile);

            this.dismiss();

        };

        //Grava no cadastro
        if (!this.copyile.Profile.ProfileCnpj && this.copyile.Profile.ProfileFlag == TProfileFlag.pfGhost) {
            onDone();
            return;
        }

        //Grava na hora
        let loading = this.util.loadingDots();
        loading.present();

        let action = (acLixo ? TAction.acLixo : TAction.acSave);
        this.profileService.contato(action, this.copyile.Profile.ProfileID, contato)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    onDone();
                    this.etapa = 0;

                },
                erro => this.util.alertResult(erro)
            );

    }

    contatoFlug(contatoRede, flug: 'class' | 'asset' | 'color' | 'negat' | 'texto' | 'value' | 'extra'): string {

        let force = (contatoRede == null);
        if (force && this.etapa == 1) contatoRede = this.contato.ContatoRede;

        let contato = this.contatoFind(contatoRede);

        if (flug == 'class') {
            if (contatoRede == TContatoTipo.coInst && (contato || force)) return 'botao-instagram';
            if (!contato && !force && this.etapa == 0)                    return 'button-border';
            return '';
        }

        if (flug == 'asset') {
            if (contatoRede == TContatoTipo.coOlha) return this.config.spotus.BrandedIcon;
            if (contatoRede == TContatoTipo.coMail) return 'b-icon-email';
            if (contatoRede == TContatoTipo.coFone) return 'b-icon-phone';
            if (contatoRede == TContatoTipo.coChip) return 'b-icon-whatsapp';
            if (contatoRede == TContatoTipo.coFace) return 'b-icon-facebook';
            if (contatoRede == TContatoTipo.coInst) return 'b-icon-instagram';
            if (contatoRede == TContatoTipo.coTube) return 'b-icon-youtube';
            if (contatoRede == TContatoTipo.coTify) return 'b-icon-spotify';
            if (contatoRede == TContatoTipo.coTikt) return 'b-icon-tiktok';
            if (contatoRede == TContatoTipo.coTwit) return 'b-icon-twitter';
        }

        if (flug == 'negat') {

            return (contato ? 'CorMilk' : 'CorGelo');

        }

        if (flug == 'color') {
            if (contatoRede == TContatoTipo.coOlha) return (contato || force ? 'CorRoxa' : 'CorMilk');
            if (contatoRede == TContatoTipo.coMail) return (contato || force ? 'CorCafe' : 'CorMilk');
            if (contatoRede == TContatoTipo.coFone) return (contato || force ? 'CorDark' : 'CorMilk');
            if (contatoRede == TContatoTipo.coChip) return (contato || force ? 'CorWhat' : 'CorMilk');
            if (contatoRede == TContatoTipo.coFace) return (contato || force ? 'CorFacebook' : 'CorMilk');
            if (contatoRede == TContatoTipo.coInst) return (contato || force ? 'CorDash' : 'CorMilk');
            if (contatoRede == TContatoTipo.coTube) return (contato || force ? 'CorTube' : 'CorMilk');
            if (contatoRede == TContatoTipo.coTify) return (contato || force ? 'CorMato' : 'CorMilk');
            if (contatoRede == TContatoTipo.coTikt) return (contato || force ? 'CorPink' : 'CorMilk');
            if (contatoRede == TContatoTipo.coTwit) return (contato || force ? 'CorTwit' : 'CorMilk');
        }

        if (flug == 'texto') {
            if (contatoRede == TContatoTipo.coNone) return 'Contato';
            if (contatoRede == TContatoTipo.coOlha) return 'Olha';
            if (contatoRede == TContatoTipo.coMail) return 'E-mail';
            if (contatoRede == TContatoTipo.coFone) return 'Telefone';
            if (contatoRede == TContatoTipo.coChip) return 'Whatsapp';
            if (contatoRede == TContatoTipo.coFace) return 'Facebook';
            if (contatoRede == TContatoTipo.coInst) return 'Instagram';
            if (contatoRede == TContatoTipo.coTube) return 'Youtube';
            if (contatoRede == TContatoTipo.coTify) return 'Spotify';
            if (contatoRede == TContatoTipo.coTikt) return 'TikTok';
            if (contatoRede == TContatoTipo.coTwit) return 'Twitter';
        }

        if (flug == 'value') {
            if (contatoRede == TContatoTipo.coMail) return (contato ? contato.ContatoUser.split('@')[0] : '');
            if (contatoRede == TContatoTipo.coOlha) return (contato ? contato.ContatoUser : '');
            if (contatoRede == TContatoTipo.coFace) return (contato ? contato.ContatoCode : '');
            if (contatoRede == TContatoTipo.coInst) return (contato ? contato.ContatoUser : '');
            if (contatoRede != TContatoTipo.coInst) return (contato ? contato.ContatoUser : '');
        }

        if (flug == 'extra') {
            if (contatoRede == TContatoTipo.coMail) return (contato ? '@' + contato.ContatoUser.split('@')[1] : '');
            if (contatoRede != TContatoTipo.coMail) return '';
        }

    }

    contatoFind(contatoRede: TContatoTipo): any {

        //USUARIO - UsuarioPara: US.Para
        if (!this.copyile) return this.contato;


        return this.copyile.Contatos.find(contato => contato.ContatoRede == contatoRede);

    }

    contatoExec(contatoRede: TContatoTipo) {

        //Ação de Contato
        this.contato = this.contatoFind(contatoRede);

        //Contato OFF - Desvincular
        if (this.contato && contatoRede == TContatoTipo.coFace) {
            let alerta = 'Desvincular sua conta?';
            this.util.alertQuestion(this.getTitle(), alerta, 'Confirmar', () => this.contatoSave(this.contato, true), false, true);
            return;
        }

        //Contato API - Automatico
        if (!this.copyile.Profile.ProfileCnpj && contatoRede == TContatoTipo.coFace) {
            this.facebook();
            return;
        }

        //Contato NEW - Novo
        if (!this.contato) {
            this.contato = {ContatoRede: contatoRede, ContatoFlag: TContatoFlag.cfNone, ContatoCode: 0, ContatoUser: '', ContatoData: '', ContatoLink: '', ContatoHash: ''};
        }

        //Contato TXT - Manual
        this.etapa = 1;

    }

    onKeydown(event) {

        return event.keyCode != 32;

    }

    onChange() {

        if (this.contato.ContatoRede != TContatoTipo.coFace) {
            this.contato.ContatoUser = this.util.textReplace(this.contato.ContatoUser, ' ', '');
            this.contato.ContatoUser = this.util.textReplace(this.contato.ContatoUser, '@', '');
            this.contato.ContatoUser = (!this.contato.ContatoUser ? '' : '@') + this.contato.ContatoUser.toLowerCase();
        }

    }

    contatoBack() {

        //Delete Contato? Volta para o inicio = 0?
        this.contato.ContatoUser = '';
        this.contato.ContatoFlag = TContatoFlag.cfNone;

    }

    contatoSend() {

        //SendCode to authenticate

    }

    contatoCopy(contato) {

        this.util.clipboardCopy(contato.ContatoUser);
        
    }

    facebook() {

        let onFace = (data) => {

            this.contato = data.contato;
            this.contatoSave(this.contato);

        };

        this.logadoService.facebook().subscribe(
            (data) => onFace(data),
            (erro) => this.util.alertResult(erro));

    }

    dismiss() {

        this.util.populateObj(this.copyile, this.rootile);

        if (this.etapa && this.etape == 0) {
            this.etapa = 0;
            return;
        }

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss();
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/contato-menu/contato-menu.ts